import {attr, controller, target} from '@github/catalyst'
import type IncludeFragmentElement from '@github/include-fragment-element'

@controller
class JobSummaryElement extends HTMLElement {
  @target fragment: IncludeFragmentElement | null
  @target loadButton: HTMLButtonElement | null
  @target retryButton: HTMLButtonElement | null
  @target loader: HTMLDivElement | null
  @target error: HTMLDivElement | null
  @attr contentPath: string

  connectedCallback() {
    if (!this.isLoaded()) {
      this.preloadIfPermalink()
    }
    if (this.fragment) {
      this.fragment.addEventListener('error', this.handleFragmentError.bind(this))
    }
  }

  isLoaded(): boolean {
    return !this.fragment
  }

  /**
   * Replace the fragment's `src` attribute with `data-content-path`, <include-fragment> will do the rest
   */
  loadSummary() {
    if (!this.fragment) {
      return
    }

    if (this.loadButton) {
      this.loadButton.hidden = true
    }

    if (this.error) {
      this.error.hidden = true
    }

    if (this.loader) {
      this.loader.hidden = false
    }

    this.fragment.src = new URL(this.contentPath, window.location.origin).toString()
  }

  /**
   * If the summary failed to load, remove the `src` attribute and force the fragment to reload
   */
  retrySummary() {
    if (!this.fragment) {
      return
    }

    this.fragment.src = ''
    this.loadSummary()
  }

  /**
   * When the <include-fragment> request fails (client side), hide the loader and show error element
   * https://github.com/github/include-fragment-element#events
   */
  private handleFragmentError() {
    if (this.loader) {
      this.loader.hidden = true
    }

    if (this.error) {
      this.error.hidden = false
    }
  }

  /**
   * Check if the window's hash is equal to the element's anchor (ie: `#summary-123`) and if so, preload the summary
   */
  private preloadIfPermalink() {
    if (`#${this.id}` === window.location.hash) {
      this.loadSummary()
    }
  }
}
